export const CommonStore = {
    state: {},
    mutations: {},
    actions: {},
    getters: {}
}